<template>
  <div class="menu-container">
    <div
      v-for="(menu) in menuList"
      :key="menu.name"
      class="menu-item-container"
      :class="isActive(menu.name)?'active':''"
      @mouseover="mouseOver"
    >
      <svg-icon class-name="icon-class icon-1" :icon-class="menu.icon + '-white'" />
      <svg-icon class-name="icon-class icon-hover" :icon-class="'hover-' + menu.icon + '-white'" />
      <span :class="['link-text', getLanguage === 'en' && 'link_text_en']">{{ menu.title }}</span>
      <!-- <div class="active-bar" /> -->
      <div v-if="menu.children && menu.children.length" class="child-menu" :style="{left: childMenuLeft + 'px'}">
        <div class="level-one-title">{{ menu.title }}</div>
        <MenuItem :base-path="menu.path" :menu="menu" />
      </div>
    </div>
  </div>
</template>

<script>
import { isSamePageTagByUrl } from '@/services/microFeUtil'
import MenuItem from './item.vue'
import { jumpTo } from './utils/jump-to'

export default {
  components: {
    MenuItem
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentMenuItemData: null,
      currentMenuItemIndex: -1,
      childMenuLeft: 59
    }
  },
  computed: {
    getLanguage() {
      return this.$i18n.locale
    }
  },

  methods: {
    onMouseOver(menu, index) {
      this.currentMenuItemData = menu
      this.currentMenuItemIndex = index
    },
    onMouseOut() {
      this.currentMenuItemData = null
    },
    goHome() {
      jumpTo(this.$router, '/')
    },
    isActive(name) {
      return name === this.getActiveName(this.menuList, this.$route.path, 0)
    },
    getActiveName(menuList, path, tier, parentName) {
      for (let i = 0; i < menuList.length; i++) {
        if (tier === 0) {
          parentName = menuList[i].name
        }
        if (menuList[i].children) {
          const name = this.getActiveName(menuList[i].children, path, tier + 1, parentName)
          if (name) {
            return name
          }
        } else {
          const flag = isSamePageTagByUrl(menuList[i].path, window.location.href)
          if (flag) {
            return parentName
          }
        }
      }
      return ''
    },
    mouseOver() {
      this.childMenuLeft = 59 - document.documentElement.scrollLeft
    }
  }
}
</script>

<style lang="scss" scoped>
// .container {
//   box-shadow: 0px -1px 0px 0px #e8e8ea;
// }
// .logo-wrap {
//   width: 100%;
//   height: 128px;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   cursor: pointer;
// }
.menu-container {
  width: 100%;
  height: calc(100% - 128px);
  .menu-item-container {
    width: 100%;
    height: 66px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
    color: #c5c5c5;
    &.firstEle {
      margin-top: 0px;
    }
    .icon-class {
      font-size: 24px;
      color: #c5c5c5;
      &.icon-1 {
        display: block;
      }
      &.icon-hover {
        display: none;
      }
    }
    .link-text {
      color: #A0A7B8;
      // color: $G8;
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      margin-top: 4px;
    }
    .link_text_en {
      font-size: 12px !important;
    }
    .active-bar {
      visibility: hidden;
      position: absolute;
      right: 0;
      width: 3px;
      height: 44px;
      background-color: rgba($color: #3b6dff, $alpha: 0.8);
      border-radius: 44px 0px 0px 44px;
    }
    .child-menu {
      display: none;
      position: fixed;
      border-left: 1px solid $G3;
      left: 59px;
      top: 0;
      height: 100vh;
      // width: 200px;
      width: 238px;
      background: #ffffff;
      box-shadow: 4px 2px 20px 0px rgba(0, 0, 0, 0.04);
      z-index: 9999;
      overflow-y: auto;
      padding: 40px 0 80px 0;
      cursor: default;
      .level-one-title {
        margin: 0 0 29px 32px;
        font-size: 18px;
        font-weight: 500;
        color: #313233;
      }
    }
    &:hover {
      background-color: rgba($color: #78B9FF, $alpha: 0.1);
      .active-bar {
        visibility: visible;
        display: none;
      }
      &.active {
        .active-bar {
          visibility: visible;
          display: block;
        }
      }
      .link-text {
        color: #ffffff;
        // color: $main-color;
      }
      .icon-class {
        color: #ffffff;
        &.icon-1 {
          display: none;
        }
        &.icon-hover {
          display: block;
        }
      }
      .child-menu {
        display: block;
      }
    }
    &.active {
      background-color: rgba($color: #78B9FF, $alpha: 0.1);
      .active-bar {
        visibility: visible;
      }
      .link-text {
        color: #ffffff;
        // color: $main-color;
      }
      .icon-class {
        color: #ffffff;
        &.icon-1 {
          display: none;
        }
        &.icon-hover {
          display: block;
        }
      }
    }
  }
}

@media screen and (max-height: 620px) {
  //窗口小于一定高度，左侧菜单栏的图标隐藏

  .menu-container {
    .menu-item-container {
      height: 40px;
      font-size: 14px;
      .active-bar {
        height: 40px;
      }
      .link-text {
        margin-bottom: 4px;
      }
      .icon-class.icon-1 {
        display: none;
      }
      &.active {
        .icon-class.icon-hover {
          display: none;
        }
      }
      &:hover {
        .icon-class.icon-hover {
          display: none;
        }
      }
    }
  }
}
</style>
